var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57952 14.3384C2.53625 13.64 1.84937 12.4508 1.84937 11.1011C1.84937 9.07369 3.39916 7.4083 5.37867 7.22497C5.78359 4.76188 7.92243 2.88281 10.5002 2.88281C13.0779 2.88281 15.2167 4.76188 15.6217 7.22497C17.6012 7.4083 19.151 9.07369 19.151 11.1011C19.151 12.4508 18.4641 13.64 17.4208 14.3384M7.03984 14.1288L10.5002 10.6685M10.5002 10.6685L13.9605 14.1288M10.5002 10.6685V18.4542",
    stroke: "#181B1F",
    strokeWidth: 1.29762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.2cae50181dc9059b8a78bd065d8d8c65.svg";
export { ForwardRef as ReactComponent };